module.exports = {
          srcSet: __webpack_public_path__ + "c6e4fe7accd33dff428fe15d73319a32-1920.png"+" 1920w",
          images:[ {path: __webpack_public_path__ + "c6e4fe7accd33dff428fe15d73319a32-1920.png",width: 1920,height: 1080}],
          src: __webpack_public_path__ + "c6e4fe7accd33dff428fe15d73319a32-1920.png",
          toString:function(){return __webpack_public_path__ + "c6e4fe7accd33dff428fe15d73319a32-1920.png"},
          
          width: 1920,
          height: 1080
        }